import { React, models, kea, resources } from "app/main/std";
import { componentToRx } from "app/logic/rx";
import { fa } from "typed-font-awesome";


class DescargarAPK extends React.PureComponent<{ permisos: models.Rol }> {
    onDescargarAPK = async () => {
        if (await kea.yesno("¿Descargar App?")) {
            const apk = await resources.ConfigSistema.GetApk();
            kea.download(kea.base64ToBlob(apk, 'application/vnd.android.package-archive'), "Uruz App.apk");
        }
    }

    render() {
        const permisos = this.props.permisos;

        return (
            permisos.VerBotonDescargarApp ?
                <kea.Button onClick={this.onDescargarAPK} style="link" iconClass={fa("android")} >
                    Descargar app
                </kea.Button> : null
        )
    }
}

export const DescargarAPKButton = kea.defaultProps(componentToRx(DescargarAPK), { permisos: resources.User.PermisoRx });


// WEBPACK FOOTER //
// ./app/features/inicio/apk.tsx